module.exports = __webpack_public_path__ + "img/2.173baf76.jpg";